import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { EndpointGroupsSearchPipeModule } from '@shared/pipes/endpoint-groups';
import { GroupsPlaceholderModule } from '@shared/components/groups-placeholder';

import { ScannerGroupsComponent } from './scanner-groups.component';

@NgModule({
  declarations: [ScannerGroupsComponent],
  exports: [ScannerGroupsComponent],
  imports: [CommonModule, FormsModule, NzCheckboxModule, NzIconModule, EndpointGroupsSearchPipeModule, GroupsPlaceholderModule],
})
export class ScannerGroupsModule { }
